module.exports = __webpack_public_path__ + "img/moon.b38b4b4e.svg";